import React, { Component } from 'react';
import avatar from './../avatar.jpg';

class MyNavbar extends Component {
  
  render() {
    const navbarInstance = (
    <section className="global-info">
        <div className="container">
            <div className="row">
            <div className="col-md-5">
                <div className="avatar">
                <img src={avatar} alt="" className="img-responsive"/>
                </div>
                <div className="name-jobtitle">
                <h2 className="title"><small>Software Developer</small>Jay Hall</h2>
                </div>
            </div>
            <div className="col-md-7 hidden-sm hidden-xs">
                <div className="address-contact">
                <div className="address">
                    <span>Location</span>
                    <p>Winnipeg,<br/>
                    Canada</p>
                </div>
                <div className="contact">
                    <span>Contact</span>
                    <p>devjayhall@gmail.com<br/>
                    <a href="https://www.jayhall.net">jayhall.net</a><br/>
                    @devjayhall</p>
                </div>
                </div>
            </div>
            </div>
        </div>
    </section>

    );
    return (
         navbarInstance
    );
  }
  
}

export default MyNavbar;



// WEBPACK FOOTER //
// ./src/components/navbar.js